import { ReactNode } from 'react';
import { Box } from '@cad-arc';
import {
    UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH,
    UNIT_SEARCH_FORM_INPUT_WIDTH,
} from '../search-windows/constants';

export function UnitStatusSearchFormGeneralFieldWrapper({ children }: { children: ReactNode }) {
    return (
        <Box w={UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH} minW={UNIT_SEARCH_FORM_INPUT_WIDTH}>
            {children}
        </Box>
    );
}
